import React, { useEffect } from "react";
import Navigationbar from "../header/Navigationbar";
import Footer from "../footer/Footer";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navigationbar />
      <div className="container mt-4 mb-4">
        <br />
        <br />
        <br />
        <br />
        <h1>Privacy Policy</h1>
        <p>
          At <strong>Currency Growth Financial Service</strong>, we value your
          privacy and are committed to protecting your personal information. We
          never sell your information to third parties. This Privacy Policy
          outlines how we collect, use, and safeguard your data when you use our
          website.
        </p>
        <h2>What We Collect</h2>
        <ul>
          <li>Name and job title</li>
          <li>Contact information, including email address</li>
          <li>
            Demographic details such as postcode, preferences, and interests
          </li>
          <li>
            Other relevant information, such as customer survey responses or
            offers
          </li>
        </ul>
        <h2>How We Use Your Information</h2>
        <ul>
          <li>Internal record keeping</li>
          <li>Improving our products and services</li>
          <li>
            Sending promotional emails about new products, special offers, or
            other relevant information
          </li>
          <li>
            Conducting market research and customizing our website based on your
            interests
          </li>
        </ul>
        <h2>Cookies</h2>
        <p>
          We use cookies to enhance your experience on our website and to ensure
          the smooth functioning of our financial services. Cookies may store
          your preferences, login details, and other relevant data to provide
          you with a seamless and personalized user experience.
        </p>
        <p>
          As a financial service provider, we prioritize the security and
          privacy of your data. The cookies we use are designed to improve our
          services, analyze website traffic, and ensure compliance with
          regulatory requirements.
        </p>
        <p>
          Please note that cookies do not give us access to your computer or any
          information beyond what you choose to share with us. You can manage
          your cookie preferences in your browser settings, but disabling
          cookies may impact certain features of our services.
        </p>
        <h2>Changes to This Policy</h2>
        <p>
          <strong>Currency Growth Financial Service</strong> may update this
          Privacy Policy from time to time. We encourage you to review this page
          periodically to ensure you’re aware of any changes.
        </p>
        <h2>Contact Us</h2>
        <p>
          If you have any concerns about this Privacy Policy, please contact us:
        </p>
        <ul>
          <li>Email: contact@cgfs.co.in</li>
          <li>Phone: +91 8479089674</li>
        </ul>

        <h1>Refund Policy</h1>
        <p>
          <strong>Business Name:</strong> Currency Growth Financial Service
        </p>
        <p>
          Refunds are typically processed within{" "}
          <strong>4–5 business days</strong>.
        </p>
        <p>
          For any questions or concerns regarding refunds, feel free to reach
          out to us via the contact information provided above.
        </p>
      </div>
      <Footer />
    </>
  );
}
